import React from "react";
import TextInput from "../../../core/form/TextInput";

let PartnerPhoneField = (props) => {

    return <TextInput
        mask='+48 999 999 999'
        name='phone'
        label='form.partner.phone'
        {...props}
    />

}

export default PartnerPhoneField